<template>
<div class="x-new-fd-index-wrapper">
    <div class="x-banner-con" v-if="xType == 'jdx'" :style="{backgroundImage:'url('+ jdxBanner+')'}"></div>
    <div class="x-banner-con" v-if="xType == 'cyx'" :style="{backgroundImage:'url('+ cyxBanner+')'}"></div>
    <div class="fd-index-main">
        <div class="work-file-con clearfix">
            <div class="fl file-list-con">
                <h3 class="h3-title-con clearfix">
                    <span class="sp-title-val fl">试点工作文件</span>
                </h3>
                <ul v-if="siteFileList.length > 0">
                    <li v-for="(item,index) in siteFileList" :key="index" class="file-item-li clearfix" @click="toFileDetail(item.docId)">
                        <i class="kd-icon-dian fl"></i>
                        <div class="file-name-con fl">{{item.name}}</div>
                    </li>
                </ul>
                <div style="margin-top:30px" v-else>
                    <noData></noData>
                </div>
            </div>
            <div class="fr file-list-con">
                <h3 class="h3-title-con clearfix">
                    <span class="sp-title-val fl">考试相关下载</span>
                </h3>
                <ul v-if="examFileList.length > 0">
                    <li v-for="(item,index) in examFileList" :key="index" class="clearfix file-item-li">
                        <a :href="item.downloadUrl" class="clearfix" :download="item.name">
                            <i class="kd-icon-dian fl"></i>
                            <div class="fl file-name-val">{{item.name}}</div>
                            <i class="fr kd-icon-xiazai2"></i>
                        </a>
                    </li>
                </ul>
                <div style="margin-top:30px" v-else>
                    <noData></noData>
                </div>
            </div>
        </div>
        
        <div class="policy-unscramble-con clearfix">
            <h3 class="h3-title-con clearfix">
                <span class="sp-title-val fl">相关入口</span>
            </h3>
            <div class="clearfix x-intro-main">
                <div class="fl policy-item-con clearfix">
                    <div class="policy-item-li fl" @click="toTeachSource">
                        <p class="p-icon-con">
                            <i class="kd-icon-xuexizhongxin"></i>
                        </p>
                        <p class="p-intro-title">教材中心</p>
                    </div>
                    <div class="policy-item-li fl">
                        <a :href="urlInfo.PeixunUrl" target="_blank">
                            <p class="p-icon-con">
                                <i class="kd-icon-peixun"></i>
                            </p>
                            <p class="p-intro-title">培训平台</p>
                        </a>
                    </div>
                    <div class="policy-item-li fl">
                        <a :href="urlInfo.MockUrl" target="_blank">
                            <p class="p-icon-con">
                                <i class="kd-icon-tikulianxi"></i>
                            </p>
                            <p class="p-intro-title">模拟考核系统</p>
                        </a>
                    </div>
                    <div class="policy-item-li fl">
                        <a href="https://vslc.ncb.edu.cn/gateway/Querydata" target="_blank">
                            <p class="p-icon-con">
                                <i class="kd-icon-chengjichaxun"></i>
                            </p>
                            <p class="p-intro-title">学生成绩/证书查询</p>
                        </a>
                    </div>
                    <div class="policy-item-li fl" @click="toScoreQuery">
                        <p class="p-icon-con">
                            <i class="kd-icon-shizizhengshu"></i>
                        </p>
                        <p class="p-intro-title">师资证书查询</p>
                    </div>
                    <div class="policy-item-li fl">
                        <a href="https://training.chinahoteledu.com/login" target="_blank" v-if="xType=='jdx'">
                            <p class="p-icon-con">
                                <i class="wl-icon-monilianxi"></i>
                            </p>
                            <p class="p-intro-title">实训系统</p>
                        </a>
                        <a href="http://fdtraining.chinahoteledu.com/login" target="_blank" v-else-if="xType=='cyx'">
                            <p class="p-icon-con">
                                <i class="wl-icon-monilianxi"></i>
                            </p>
                            <p class="p-intro-title">实训系统</p>
                        </a>
                    </div>
                </div>
                <!-- <div class="fr x-intro-con" :style="{backgroundImage:'url('+ introImg1 +')'}">
                    <div class="x-intro-detail-1">
                        <h2>
                            <span v-if="xType == 'jdx'">酒店运营管理</span>
                            <span v-if="xType == 'cyx'">餐饮管理运行</span>
                            <span>职业技能等级考试</span>
                        </h2>
                        <div class="zs-img-con">
                            <img :src="zhengshu" alt="" class="img-val" @click="zhengshuShow = true">
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
        <!-- <div class="policy-unscramble-con clearfix">
            <h3 class="h3-title-con clearfix">
                <span class="sp-title-val fl">友情链接</span>
            </h3>
            <div class="clearfix x-intro-main">
                <div class="fl policy-item-con clearfix">
                    <a href="https://www.moe.gov.cn/" target="_blank" class="link-item-li" :style="{'background-image': 'url('+link1+')'}"></a>
                    <a href="https://www.ncb.edu.cn/" class="link-item-li" target="_blank" :style="{'background-image': 'url('+link2+')'}"></a>
                    <a href="https://vslc.ncb.edu.cn/" class="link-item-li" target="_blank" :style="{'background-image': 'url('+link3+')'}"></a>
                </div>
                <div class="fr x-intro-con" :style="{backgroundImage:'url('+ introImg2 +')'}">
                    <div class="x-intro-detail-2">
                        <h2>
                            <span v-if="xType == 'jdx'">酒店运营管理</span>
                            <span v-if="xType == 'cyx'">餐饮管理运行</span>
                            <span>职业技能等级考试</span>
                        </h2>
                        <p class="p-link-ways">联系方式</p>
                        <div class="intro-line-con"></div>
                        <div>
                            <span style="margin-right:80px;">张翔：152 1079 1982 </span>
                            <span>杨晨驰：138 1543 3791</span>
                        </div>
                        <div class="clearfix">
                            <div class="fl ecorde-intro-con">
                                <img :src="linkWx1" alt="" class="ecorde-img-val">
                                <p>张翔微信</p>
                            </div>
                            <div class="fl ecorde-intro-con ecorde-intro-con-last">
                                <img :src="linkWx2" alt="" class="ecorde-img-val">
                                <p>杨晨驰微信</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
    <!-- 证书放大 -->
    <el-dialog :visible="zhengshuShow" width="800px" @close="zhengshuShow = false">
        <div class="dialog-zhengshu-con">
            <p class="p-zhengshu-title">职业技能等级证书样例</p>
            <img :src="zhengshu" alt="" class="img-val">
        </div>
    </el-dialog>
</div>
</template>

<script>
import noData from 'components/noData.vue';
export default {
    data() {
        return {
            jdxBanner: require('assets/images/jdx-banner.png'),
            cyxBanner: require('assets/images/cyx-banner.png'),
            link1: require('assets/images/link-1.png'),
            link2: require('assets/images/link-2.png'),
            link3: require('assets/images/link-3.png'),
            siteFileList: [],
            examFileList: [],
            urlInfo: {},
            introImg1: require('assets/images/fd-index-img-1.png'),
            introImg2: require('assets/images/fd-index-img-2.png'),
            ecordeImg: require('assets/images/ecorde-img.png'),
            linkWx1: require('assets/images/zx-wx.jpg'),
            linkWx2: require('assets/images/ycc-wx.png'),
            policyFileList: [],
            zhengshu: require('assets/images/zhengshu.png'),
            zhengshuShow: false
        }
    },
    components: {
        noData
    },
    props: {
        xType: {
            type: String,
            default: ''
        }
    },
    created() {
        this.getCertificateInfo();
    },
    watch: {
        xType() {
            this.getCertificateInfo();
        }
    },
    methods: {
        toViewFile(id, docId) {
            if (!docId) {
                return this.$message.warning('暂无文件');
            } else {
                this.$router.push({
                    name: 'policyfileDetail',
                    params: {
                        xType: this.xType,
                        fileId: docId
                    }
                });
            }
        },
        toDownloadSoftware() {
            this.$router.push({
                name: 'softwareDownload',
                params: {
                    xType: this.xType
                }
            });
        },
        toFileDetail(id) {
            this.$router.push({
                name: 'fileDocDetail',
                params: {
                    xType: this.xType,
                    fileId: id
                }
            });
        },
        getCertificateInfo() {
            this.$http.post("/api/XOrg/homePage/getCertificateInfo", {
                xType: this.xType
            }).then(rst => {
                if (rst.code > 0) {
                    this.siteFileList = rst.siteFileList.length > 5 ? rst.siteFileList.slice(0, 5) : rst.siteFileList;
                    this.examFileList = rst.examFileList.length > 6 ? rst.examFileList.slice(0, 6) : rst.examFileList;
                    this.policyFileList = rst.policyFileList;
                    this.urlInfo = rst.urlInfo;
                }
            });
        },
        toTeachSource() {
            this.$router.push({
                name: 'studyCenter',
                params: {
                    xType: this.xType
                }
            });
        },
        toMoreFile() {
            this.$router.push({
                name: 'fileDoc',
                params: {
                    xType: this.xType
                }
            });
        },
        toStudyCenter() {
            this.$router.push({
                name: 'studyCenter',
                params: {
                    xType: this.xType
                }
            });
        },
        toFileDownload() {
            this.$router.push({
                name: 'fileDownload',
                params: {
                    xType: this.xType
                }
            });
        },
        toScoreQuery() {
            this.$router.push({
                name: 'certifyIndex',
                params: {
                    xType: this.xType
                }
            });
        },
        toSearchCerfity() {
            this.$router.push({
                name: 'certifyIndex',
                params: {
                    xType: this.xType
                }
            });
        }
    }
}
</script>

<style lang="scss">
.x-new-fd-index-wrapper {
    .x-banner-con {
        height: 240px;
        background-size: cover;
        background-position: center top;
        background-repeat: no-repeat;
    }

    .fd-index-main {
        margin: 35px auto;
        width: 1200px;

        .file-list-con {
            width: 580px;
            min-height: 200px;
        }

        .h3-title-con {
            border-bottom: 2px solid #F0EBEB;
        }

        .sp-title-val {
            margin-bottom: -2px;
            height: 38px;
            line-height: 38px;
            color: #05243D;
            font-size: 18px;
            border-bottom: 2px solid #05243D;
        }

        .file-item-li {
            height: 50px;
            line-height: 50px;
            font-size: 14px;
            color: #333333;
            border-bottom: 1px dashed #dddddd;
            cursor: pointer;

            a {
                color: #333333;
            }
        }

        .file-item-li:hover {
            color: #05243D;

            a {
                color: #05243D;
            }
        }

        .file-name-con {
            margin-left: 10px;
            width: 500px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }

        .policy-unscramble-con {
            margin-top: 40px;
        }

        .x-intro-con {
            margin-top: 15px;
            width: 610px;
            height: 375px;
        }

        .policy-item-con {
            width: 100%;
        }

        .x-intro-main {
            padding-top: 15px;
        }

        .policy-item-li {
            margin: 15px 24px 0 0;
            width: 180px;
            height: 180px;
            text-align: center;
            color: #05243d;
            background: #F0EBEB;
            cursor: pointer;
            transition: all .4s;

            a {
                display: block;
                width: 100%;
                height: 100%;
                color: #05243d;
            }

            .p-icon-con {
                padding-top: 45px;

                i {
                    font-size: 45px;
                }
            }

            .p-intro-title {
                margin-top: 10px;
                color: #05243d;
                font-size: 16px;
            }
        }
        .link-item-li{
            display: block;
            margin-top: 15px;
            width: 100%;
            height: 115px;
        }

        .policy-item-li:last-child {
            margin-right: 0;
        }

        .policy-item-li:hover {
            background: #05243D;
            color: #fff;

            .p-intro-title {
                color: #fff;
            }

            a {
                color: #fff;
            }
        }

        .x-intro-detail-1 {
            padding-top: 30px;
            color: #fff;

            h2 {
                font-size: 32px;
                text-align: center;
            }

            .intro-line-con {
                width: 60px;
                height: 5px;
                background: #FFFFFF;
            }

            .intro-item-con {
                margin-bottom: 30px;
                font-size: 20px;

                span {
                    cursor: pointer;
                }

                .sp-in-line {
                    margin: 0 15px;
                }
            }

            .zs-img-con {
                text-align: center;

                .img-val {
                    margin-top: 17px;
                    width: 380px;
                    transition: all .3s;
                    cursor: pointer;
                }

                .img-val:hover {
                    transform: scale(1.1);
                }
            }
        }

        .x-intro-detail-2 {
            padding-top: 31px;
            margin-left: 30px;
            color: #fff;

            h2 {
                font-size: 32px;
            }

            .p-link-ways {
                margin-top: 10px;
                font-size: 26px;
            }

            .intro-line-con {
                margin: 20px 0;
                width: 60px;
                height: 5px;
                background: #FFFFFF;
            }

            .ecorde-img-val {
                width: 120px;
            }

            .ecorde-intro-con {
                margin: 30px 100px 0 0;
                text-align: center;
                font-size: 14px;
            }

            .ecorde-intro-con-last {
                margin: 30px 0 0 0;
            }
        }
    }

    .dialog-zhengshu-con {
        .img-val {
            width: 100%;
        }

        .p-zhengshu-title {
            margin: 10px 0;
            font-size: 29px;
            text-align: center;
        }
    }
}

@media only screen and (max-width: 768px) {
    .x-new-fd-index-wrapper {
        margin-bottom: 40px;

        .x-banner-con {
            height: 90px;
        }

        .fd-index-main {
            margin: 15px 0;
            padding: 0 10px;
            width: 100%;
            box-sizing: border-box;

            .file-list-con {
                float: none;
                width: 100%;
                min-height: 120px;
            }

            .h3-title-con {
                border-bottom: 1px solid #F0EBEB;
            }

            .sp-title-val {
                margin-bottom: -1px;
                height: 34px;
                line-height: 34px;
                font-size: 15px;
                border-bottom: 1px solid #05243D;
            }

            .file-item-li {
                height: 34px;
                line-height: 34px;
            }

            .file-name-con {
                width: calc(100% - 60px);
            }

            .policy-item-con {
                float: none;
                width: 100%;
            }

            .policy-item-li {
                margin-right: 5%;
                width: 30%;
                height: 110px;

                .p-intro-title {
                    margin-top: 5px;
                }

                .p-icon-con i {
                    font-size: 31px;
                }

                .p-intro-title {
                    font-size: 13px;
                }

                .p-icon-con {
                    padding-top: 24px;
                }
                &:nth-child(3n){
                    margin-right: 0;
                }
            }

            .x-intro-con {
                display: none;
            }

            .policy-unscramble-con {
                margin-top: 20px;
            }
        }
    }
}
</style>
